import { render, staticRenderFns } from "./widget_voice_campaign.vue?vue&type=template&id=b72b14ca&"
import script from "./widget_voice_campaign.vue?vue&type=script&lang=js&"
export * from "./widget_voice_campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports